type Classes = string | number | boolean | null | undefined

export const cx = (...args: Classes[]): string => {
  return [...args].filter(Boolean).join(' ')
}
